/**
 * Client-side canvas utility: turns a square photo into a 1080x1920 (9:16)
 * Instagram Stories / Reels ready image with a blurred background of itself.
 */
export async function downloadForStories(imageUrl, filename = "story.jpg") {
  const img = await loadImage(imageUrl);
  const W = 1080;
  const H = 1920;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Blurred background = image stretched to cover
  ctx.filter = "blur(40px) brightness(0.55)";
  // cover-fit
  const scale = Math.max(W / img.width, H / img.height) * 1.15;
  const bw = img.width * scale;
  const bh = img.height * scale;
  ctx.drawImage(img, (W - bw) / 2, (H - bh) / 2, bw, bh);
  ctx.filter = "none";

  // Foreground: contain-fit centered
  const pad = 60;
  const maxW = W - pad * 2;
  const maxH = H - pad * 2 - 220; // leave space for footer
  const fs = Math.min(maxW / img.width, maxH / img.height);
  const fw = img.width * fs;
  const fh = img.height * fs;
  const fx = (W - fw) / 2;
  const fy = (H - fh) / 2 - 40;

  // subtle drop shadow
  ctx.shadowColor = "rgba(0,0,0,0.45)";
  ctx.shadowBlur = 40;
  ctx.shadowOffsetY = 12;
  ctx.drawImage(img, fx, fy, fw, fh);
  ctx.shadowColor = "transparent";

  // Footer branding
  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(255,255,255,0.95)";
  ctx.font = "bold 42px 'Unbounded', 'Outfit', sans-serif";
  ctx.fillText("FESTAGRAM", W / 2, H - 90);
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = "400 26px 'Outfit', sans-serif";
  ctx.fillText("compartilhe suas memórias", W / 2, H - 50);

  const blob = await new Promise((res) =>
    canvas.toBlob(res, "image/jpeg", 0.92),
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
